import * as React from 'react';
import { Box, Drawer, useMediaQuery, useTheme } from '@mui/material';

export const CerebroNavigationDrawer: React.FC<CerebroNavigationDrawerProps> = ({ open, onClose, children }) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));

	return isMobile ? (
		<Drawer
			variant="temporary"
			open={open}
			onClose={onClose}
			PaperProps={{
				sx: theme => ({
					backgroundColor: theme.palette.gray.background,
					width: '100vw',
				}),
			}}
		>
			{children}
		</Drawer>
	) : (
		<Box
			sx={{
				backgroundColor: theme => theme.palette.gray.background,
				paddingLeft: 2,
				paddingRight: 4,
			}}
		>
			{children}
		</Box>
	);
};

interface CerebroNavigationDrawerProps {
	open: boolean;
	onClose: () => void;
}
